/* External */
import { useCallback } from 'react';

/* Utils */
import { redirectToPlayer } from '../utils/history';

export default function useRedirectToPlayer(entityInstance, {
  page, section, replace, query, state,
}) {
  return useCallback(
    () => redirectToPlayer(entityInstance, {
      page,
      section,
      replace,
      query,
      state,
    }),
    [entityInstance, page, section, state, replace, query],
  );
}
